import { useEffect, useState } from "react";
import useAuth from "./useAuth";
import useCustomRouting from "./useCustomRouting";

const useProfile = () => {
  const [profile, setprofile] = useState(null);
  const [tokenData, setTokenData] = useState();
  const { token } = useAuth();

  function decodeJWT(token) {
    const [header, payload, signature] = token.split(".");
    const decodedPayload = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
    );
    setTokenData(decodedPayload);
    return decodedPayload;
  }

  const getProfileDetails = (token) => {
    const decodedData = decodeJWT(token);
    setprofile({
      givenName: decodedData?.given_name || "",
      surname: decodedData?.family_name || "",
      image: "",
    });
  };

  useEffect(() => {
    if (token) {
      getProfileDetails(token);
    }
  }, [token]);
  return { profile, tokenData };
};

export default useProfile;
